const KEY = "keyvision.progressions.v1";

export function loadProgressions() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function saveProgressions(list) {
  localStorage.setItem(KEY, JSON.stringify(list));
}

export function addProgression(name, chords) {
  const list = loadProgressions();
  const idx = list.findIndex((p) => p.name === name);
  const entry = { name, chords };
  if (idx >= 0) list[idx] = entry;
  else list.push(entry);
  saveProgressions(list);
  return list;
}

export function deleteProgression(name) {
  const list = loadProgressions().filter((p) => p.name !== name);
  saveProgressions(list);
  return list;
}
